import { ca } from '@cian/analytics';

import { TChatInListSchema } from '../../types/chatList';
import { EChatRole } from '../../types/userData';
import { getCategory } from '../../utils/trackings_helpers';

export enum EGroupActions {
  Read = 'GroupActionRead',
  Delete = 'GroupActionDelete',
  Archive = 'GroupActionArchived',
  Unarchive = 'GroupActionUnarchived',
}

export const trackGroupActionClick = (action: EGroupActions, chats?: TChatInListSchema[]) => {
  const opponentId: number[] = [];

  if (chats?.length) {
    chats.map(({ users }) => {
      const opponent = users.find(user => user.chatRole === EChatRole.Opponent);

      if (opponent) {
        opponentId.push(opponent.userId);
      }
    });
  }
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action,
    label: 'Click_sopr',
    page: {
      extra: {
        allChatsAction: !chats,
        opponent_id: opponentId,
      },
    },
    products: chats
      ? chats.map(({ chatId, data: { offer } = {} }) => {
          if (!offer) {
            return {
              extra: { chatId },
            };
          }

          const category = getCategory(offer);

          const [dealType, objectType] = category.split('/');

          return {
            brand: '',
            category,
            cianId: offer.id,
            dealType,
            hiddenBase: false,
            id: offer.id,
            objectType,
            price: offer.bargainTerms.priceRur,
            published: true,
            // Всегда передаем 1
            quantity: 1,
            variant: [],
            extra: { chatId },
          };
        })
      : undefined,
  });
};
